export const TIME_ATTENDANCE_DISPLAY_LIMIT = 25;
export const TimeAttendanceListButtonIconSize = '20px';
export const RESPONSE_MESSAGE = {
  UPDATE_SUCCESS: 'Updated Successfully',
  CREATE_SUCCESS: 'Created Successfully',
};
export const CalendarFormats = {
  dateFormat: 'd/m/Y',
  dateTimeFormat: 'd/m/Y H:i:S',
};
export const TimeAttendanceListActionButtons = {
  button: {
    width: '30px',
    height: '30px',
  },
  icon: '20px',
};

export const timeAttendanceTableColumnConfig: any = {
  id: {
    label: 'ID',
    textColumnStyle: 'text-left',
    columnWidth: {
      web: {
        minWidth: '80px',
        maxWidth: '100px',
      },
      mobile: {
        minWidth: '60px',
        maxWidth: '80px',
      },
    },
  },
  office_id: {
    label: 'Office ID',
    textColumnStyle: 'text-left',
    columnWidth: {
      web: {
        minWidth: '90px',
        maxWidth: '110px',
      },
      mobile: {
        minWidth: '80px',
        maxWidth: '100px',
      },
    },
  },
  office_code: {
    label: 'Employee Code',
    textColumnStyle: 'text-left',
    columnWidth: {
      // web: {
      //   minWidth: '110px',
      //   maxWidth: '140px',
      // },
      // mobile: {
      //   minWidth: '100px',
      //   maxWidth: '120px',
      // },
      web: {
        minWidth: '90px',
        maxWidth: '110px',
      },
      mobile: {
        minWidth: '80px',
        maxWidth: '100px',
      },
    },
  },
  full_name: {
    label: 'Employee Name',
    textColumnStyle: 'text-left',
    columnWidth: {
      // web: {
      //   minWidth: '160px',
      //   maxWidth: '220px',
      // },
      // mobile: {
      //   minWidth: '140px',
      //   maxWidth: '180px',
      // },
      web: {
        minWidth: '110px',
        maxWidth: '140px',
      },
      mobile: {
        minWidth: '100px',
        maxWidth: '120px',
      },
    },
  },
  branch_code: {
    label: 'Branch Code',
    textColumnStyle: 'text-left',
    columnWidth: {
      web: {
        minWidth: '110px',
        maxWidth: '130px',
      },
      mobile: {
        minWidth: '100px',
        maxWidth: '120px',
      },
    },
  },
  clock_in_at: {
    label: 'Clock-in Time',
    textColumnStyle: 'text-left',
    columnWidth: {
      // web: {
      //   minWidth: '140px',
      //   maxWidth: '180px',
      // },
      // mobile: {
      //   minWidth: '120px',
      //   maxWidth: '160px',
      // },
      web: {
        minWidth: '110px',
        maxWidth: '150px',
      },
      mobile: {
        minWidth: '120px',
        maxWidth: '160px',
      },
    },
  },
  clock_out_at: {
    label: 'Clock-out Time',
    textColumnStyle: 'text-left',
    columnWidth: {
      // web: {
      //   minWidth: '140px',
      //   maxWidth: '180px',
      // },
      // mobile: {
      //   minWidth: '120px',
      //   maxWidth: '160px',
      // },
      web: {
        minWidth: '110px',
        maxWidth: '150px',
      },
      mobile: {
        minWidth: '120px',
        maxWidth: '160px',
      },
    },
  },
  // working_minutes: {
  //   label: 'Working Minutes',
  //   textColumnStyle: 'text-end',
  //   columnWidth: {
  //     // web: {
  //     //   minWidth: '120px',
  //     //   maxWidth: '150px',
  //     // },
  //     // mobile: {
  //     //   minWidth: '100px',
  //     //   maxWidth: '130px',
  //     // },
  //     // web: {
  //     //   minWidth: '110px',
  //     //   maxWidth: '130px',
  //     // },
  //     // mobile: {
  //     //   minWidth: '100px',
  //     //   maxWidth: '120px',
  //     // },
  //     web: {
  //       minWidth: '90px',
  //       maxWidth: '110px',
  //     },
  //     mobile: {
  //       minWidth: '80px',
  //       maxWidth: '100px',
  //     },
  //   },
  // },
  // breaking_minutes: {
  //   label: 'Breaking Minutes',
  //   textColumnStyle: 'text-end',
  //   columnWidth: {
  //     // web: {
  //     //   minWidth: '120px',
  //     //   maxWidth: '150px',
  //     // },
  //     // mobile: {
  //     //   minWidth: '100px',
  //     //   maxWidth: '130px',
  //     // },
  //     web: {
  //       minWidth: '90px',
  //       maxWidth: '110px',
  //     },
  //     mobile: {
  //       minWidth: '80px',
  //       maxWidth: '100px',
  //     },
  //   },
  // },
  working_hours: {
    label: 'Working Hours',
    textColumnStyle: 'text-end',
    columnWidth: {
      web: {
        minWidth: '90px',
        maxWidth: '110px',
      },
      mobile: {
        minWidth: '80px',
        maxWidth: '100px',
      },
    },
  },
  breaking_hours: {
    label: 'Breaking Hours',
    textColumnStyle: 'text-end',
    columnWidth: {
      web: {
        minWidth: '90px',
        maxWidth: '110px',
      },
      mobile: {
        minWidth: '80px',
        maxWidth: '100px',
      },
    },
  },
  note: {
    label: 'Note',
    textColumnStyle: 'text-left',
    columnWidth: {
      // web: {
      //   minWidth: '180px',
      //   maxWidth: '240px',
      // },
      // mobile: {
      //   minWidth: '140px',
      //   maxWidth: '180px',
      // },
      web: {
        minWidth: '160px',
        maxWidth: '180px',
      },
      mobile: {
        minWidth: '140px',
        maxWidth: '180px',
      },
    },
  },
};

export const getTimeAttendanceColumnWidth = (
  isMobile: boolean,
  id: keyof typeof timeAttendanceTableColumnConfig,
  type: 'minWidth' | 'maxWidth'
): string | undefined => {
  const styleMap = isMobile ? 'mobile' : 'web';

  return timeAttendanceTableColumnConfig[id].columnWidth[styleMap][type];
};
